import React from "react";
import { Link } from "react-router-dom";
import { UtensilsCrossed, CalendarCheck } from "lucide-react";

export default function MobileCTABar() {
  return (
    <div
      data-testid="mobile-sticky-cta-bar"
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-charcoal/95 backdrop-blur-md border-t border-white/10 px-3 py-2.5 flex gap-2"
      style={{ paddingBottom: "max(0.625rem, env(safe-area-inset-bottom))" }}
    >
      <Link
        to="/meal-prep"
        data-testid="mobile-cta-meal-prep"
        className="flex-1 inline-flex items-center justify-center gap-2 rounded-full bg-white/10 text-white px-4 py-3 text-sm font-semibold"
      >
        <UtensilsCrossed className="w-4 h-4" /> Meal Prep
      </Link>
      <Link
        to="/contact"
        data-testid="mobile-cta-quote"
        className="flex-1 inline-flex items-center justify-center gap-2 rounded-full bg-gold text-charcoal px-4 py-3 text-sm font-semibold"
      >
        <CalendarCheck className="w-4 h-4" /> Request a Quote
      </Link>
    </div>
  );
}
